import axios from "@/utils/axiosHelper";

// 提灯迷宫联动
// 初始化
export const onGetInitDataAPI = (params) => {
  return axios(
    { url: "/lantern/maze/init", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 点击预约
export const appointAPI = (params) => {
  return axios(
    { url: "/lantern/maze/book", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 绑定角色 和 领取奖励接口 一个传 1 一个传0
export const bindRoleAndGetAwardAPI = (params) => {
  return axios(
    { url: "/lantern/maze/reward", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 领取彩蛋
export const getEggRewardAPI = (params) => {
  return axios(
    { url: "/lantern/maze/egg", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 点击助力
export const onHelpAPI = (params) => {
  return axios(
    { url: "/lantern/maze/help", method: "POST", params },
    { interceptResultCode: false }
  );
};

//  点击迷宫箱子
export const clickFkAPI = (params) => {
  return axios(
    { url: "/lantern/maze/lottery", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 新登出
export const LogoutAPI = (params) => {
  return axios(
    { url: "/game/my/disable", method: "POST", params },
    { interceptResultCode: false }
  );
};

export const downloadApps = (params) => {
  return axios(
    { url: "/jump/download/url", method: "POST", params },
    { interceptResultCode: false }
  );
};



// WEBPACK FOOTER //
// ./src/pages/tideng/maze/api.js